var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopping = function SvgShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54 44.076v-26.72c0-2.166 1.757-3.924 3.923-3.924h5.105v-2.105C13.568 5.24 18.083 0 24 0c5.92 0 10.436 5.24 10.436 11.327v2.105h5.103c2.163 0 3.922 1.758 3.922 3.923v26.72c0 2.166-1.76 3.925-3.923 3.925H8.462c-2.166 0-3.924-1.76-3.924-3.924zm35.53 0v-26.72c0-.294-.238-.533-.53-.533h-5.104v5.455c0 .98-.794 1.772-1.77 1.772-.98 0-1.774-.793-1.774-1.772v-5.455h-13.78v5.455c0 .98-.795 1.772-1.773 1.772-.98 0-1.772-.793-1.772-1.772v-5.455H8.463c-.295 0-.534.24-.534.532v26.72c0 .296.238.534.533.534H39.54c.292 0 .53-.24.53-.534zm-9.178-30.644v-2.105c0-4.464-3.248-7.783-6.89-7.783-3.643 0-6.89 3.32-6.89 7.783v2.105h13.78z"
  })));
};
export default SvgShopping;